import React from "react";
import { useNavigate } from "react-router-dom";

import LeftSide from "../pageComponents/LeftSide";
import PassImg from "../../assets/img/Password-change.png";
import { MimaButton } from '../../components';
import styles from "../../assets/styles/Login/Login.module.scss";
import constant from "../../utils/constant";
// To navigate pages

const PasswordChangeSuccess = () => {
  const navigate = useNavigate();
  const switchToLogin = () => {
    navigate(constant.Routes.Login);
  };

  return (
    <div className={styles.container}>
      <LeftSide title="Welcome Back :)" />
      <div className={styles.rightside}>
        <img
          src={PassImg}
          className={styles.pw__img}
          alt="Password Change Success"
        />
        <div className={styles.logintext__center}>
          <div className={`${styles.logintext__p} ${styles.mt_40}`}>
            Password change <br />
            <span className={styles.success__h3}> Successful </span>
          </div>

          <MimaButton
            title="Continue to Login"
            width={38}
            onClick={switchToLogin}
          />
        </div>
      </div>
    </div>
  );
};

export default PasswordChangeSuccess;
